'use client'

import { LocaleType } from '@/i18n/routing';
import { useEffect } from 'react';
import useGeneralStore from '@/store/general';
import FooterDesktop from '@/components/FooterDesktop';

type Props = {
    locale: LocaleType
    tenant: string
    texts: any
    folder?: string
    configInfo: any
}

export default function ClientLayoutDesktopBottom({ locale, tenant, texts, folder, configInfo }: Props) {

    const { theme } = useGeneralStore()
    useEffect(() => {
        if (theme == 'dark') {
            document.documentElement.classList.add('dark')
        } else {
            document.documentElement.classList.remove('dark')
        }
    }, [theme])

    return (
        <></>
        // <FooterDesktop locale={locale} tenant={tenant} texts={texts} folder={folder} configInfo={configInfo} />
    )
}